import { jsx } from "react/jsx-runtime";
import '../common/components/ccam-flag/ccam-flag.css';function CCAMFlag({ show }) {
  if (!show) {
    return null;
  }
  return /* @__PURE__ */ jsx("div", { className: "ccam-flag-wrapper", children: /* @__PURE__ */ jsx("div", { className: "ccam-flag" }) });
}
export {
  CCAMFlag
};
//# sourceMappingURL=ccam-flag.js.map
